import React, {ReactNodeArray, useCallback} from "react";
import {Fab, makeStyles} from "@material-ui/core";
import {FloatButtonColor, FloatButtonSize, FloatButtonVariant} from "../../models/element";

interface FloatButtonStyleProps {
    // サイズ
    size?: FloatButtonSize;
    // 配色
    color?: FloatButtonColor;
    // 表示形式
    variant?: FloatButtonVariant;
    // 文字サイズ
    fontSize?: string;
    // 活性化
    isActive?: boolean;
}

interface FloatButtonProps extends FloatButtonStyleProps {
    // 要素ID
    id?: string;
    // 内容
    children: ReactNodeArray;
    // クリックイベント
    onClick: () => void;
}

const useStyles = makeStyles({
    fullWidth: {
        width: "100%",
        backgroundColor: "var(--red)",
        "&:hover": {
            backgroundColor: "rgb(193, 0, 25)",
       }
   }
});

function PuiFloatButton({id, children, onClick, ...props}: FloatButtonProps) {
    const {size = "small", color = "secondary", variant = "extended", fontSize = "0.875rem", isActive = true} = props;
    const classes = useStyles();

    const handleClick = useCallback(() => {
        if (onClick) {
            onClick();
       }
   }, [onClick]);

    return (
        <Fab
            id={id}
            size={size}
            color={color}
            variant={variant}
            disabled={!isActive}
            style={{fontSize: fontSize}}
            onClick={handleClick}
            className={classes.fullWidth}
        >
            {children}
        </Fab>
    );
}

export default PuiFloatButton;
